import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Copy } from 'lucide-react';
import { toast } from 'sonner';

const EMAIL = `Hi, we use Front Desk Pro to answer our business phone calls. We'd like it to check our inventory (what's in stock and the prices) while it's on a call with a customer.
Do you offer an API that lets it look up our inventory?
If yes, could you send us:
1. The API link for looking up our inventory
2. A read-only API key
Thank you!`;

const STEPS = [
  ['Think of where your stock and prices are kept', 'The program or website you already use to track products, parts or prices.'],
  ['Look in its settings', 'Many programs have a page called API, Integrations or Developers. There you can create a key (choose "read-only") and find the link.'],
  ['Not sure? Ask them', 'Copy the message below and send it to that program\'s support team. They will reply with the link and key.'],
  ['Paste them here and test', 'Fill in the form below, press Save, then press the play button and type a real product name. If you see your product, you\'re done.'],
];

export const ApiKeyGuide = () => {
  const [open, setOpen] = useState(true);
  const copy = () => { navigator.clipboard.writeText(EMAIL); toast.success('Message copied'); };

  return (
    <div className="rounded-xl bg-muted/40 border border-border" data-testid="api-key-guide">
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-4 text-left" data-testid="api-key-guide-toggle">
        <span className="text-sm font-semibold text-foreground">Where do I get the link and key?</span>
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-4">
          <ol className="space-y-3">
            {STEPS.map(([t, d], i) => (
              <li key={t} className="flex gap-3">
                <span className="w-6 h-6 shrink-0 rounded-full bg-primary text-white text-xs flex items-center justify-center">{i + 1}</span>
                <span className="text-sm"><span className="font-medium text-foreground">{t}.</span> <span className="text-muted-foreground">{d}</span></span>
              </li>
            ))}
          </ol>
          <div className="rounded-lg bg-background border border-border p-3">
            <pre className="text-xs whitespace-pre-wrap text-muted-foreground font-sans" data-testid="api-key-guide-email">{EMAIL}</pre>
            <button type="button" onClick={copy} className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-primary hover:underline" data-testid="api-key-guide-copy-btn">
              <Copy className="w-3.5 h-3.5" /> Copy message
            </button>
          </div>
          <p className="text-xs text-muted-foreground">Your Pro only reads your stock and prices. It never changes anything. If your program has no API, it can't be connected.</p>
        </div>
      )}
    </div>
  );
};
